import React from 'react';
import { motion } from 'framer-motion';
import { MousePointerClick, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function WhyWebpagesBanner() {
  return <section className="py-16 bg-sum-charcoal relative overflow-hidden" data-id="element-228">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-229">
        <div className="absolute -top-24 -left-24 w-64 h-64 rounded-full bg-sum-green opacity-10 blur-3xl" data-id="element-230"></div>
        <div className="absolute -bottom-24 -right-24 w-64 h-64 rounded-full bg-sum-gold opacity-10 blur-3xl" data-id="element-231"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-232">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-r from-gray-800 to-gray-900 rounded-2xl p-8 md:p-12 shadow-2xl border border-gray-700 flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-233">
          <div className="flex-1 text-center md:text-left" data-id="element-234">
            <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4" data-id="element-235">
              Why is a Website <span className="text-sum-gold" data-id="element-236">Imperative</span>{' '}
              for Your Business?
            </h2>
            <p className="text-lg text-gray-300 max-w-2xl" data-id="element-237">
              In today's digital age, not having a website is like having a
              closed sign on your front door. Discover the top reasons why you
              need a dedicated online presence.
            </p>
          </div>

          <motion.div whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="flex-shrink-0" data-id="element-238">
            <Link to="/why-webpages" className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-sum-charcoal bg-sum-gold rounded-full overflow-hidden transition-all hover:bg-yellow-400 shadow-[0_0_20px_rgba(255,215,0,0.3)]" data-id="element-239">
              <motion.div animate={{
              y: [0, -5, 0]
            }} transition={{
              repeat: Infinity,
              duration: 1.5,
              ease: 'easeInOut'
            }} className="mr-3" data-id="element-240">
                <MousePointerClick size={24} data-id="element-241" />
              </motion.div>
              Click Here to Find Out
              <ArrowRight size={20} className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-242" />
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}